import { getSchemeDetails } from '@/services/PlanInfo';
import { useParams, useRequest } from '@umijs/max';
import { useEffect, useState } from 'react';

export default () => {
  const urlParams = useParams();
  const { id } = urlParams;
  const [addSquareModal, setAddSquareModal] = useState<boolean>(false);
  const [planData, setPlanData] = useState<any>({});

  const { run: getSchemeDetailsFn } = useRequest(getSchemeDetails, {
    manual: true,
    throttleInterval: 1000,
    onSuccess: (data) => {
      if (data.status === 0) {
        setPlanData(data.payload);
      }
    },
  });
  return {
    planData,
    addSquareModal,
    setAddSquareModal,
    getSchemeDetailsFn
  };
};
